import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { utilTransportLocationFormDefault } from "@factory/form/form.default";
import { UtilTransportLocationFormRule, UtilTransportLocationFormSchema } from "@factory/form/form.rule";
import { useQyCreateUtilTransportLocation } from "@factory/query/util-transport-location.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewUtilTransportLocation() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateUtilTransportLocation } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New UtilTransportLocation is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addUtilTransportLocation, isLoading: isCreating } =
    useQyCreateUtilTransportLocation(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<UtilTransportLocationFormSchema>({
    defaultValues: utilTransportLocationFormDefault,
    resolver: zodResolver(UtilTransportLocationFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: UtilTransportLocationFormSchema) => {
    const formData = mapCreateUtilTransportLocation(form);
    addUtilTransportLocation(formData);
  };
  const handleValidateError = (err: FieldErrors<UtilTransportLocationFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
